export default "__VITE_ASSET__COrttg7B__"